/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * Defines the type of errors that have occurred in the service.
 **/
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["INVITATION_ALREADY_EXISTS"] = "INVITATION_ALREADY_EXISTS";
    ErrorCode["INVITED_USER_ALREADY_AUTHORIZED"] = "INVITED_USER_ALREADY_AUTHORIZED";
    ErrorCode["ACCEPTED_USER_IS_ALREADY_AUTHORIZED"] = "ACCEPTED_USER_IS_ALREADY_AUTHORIZED";
    ErrorCode["INVITATION_IS_ACCEPTED_BY_DIFFERENT_CUSTOMER"] = "INVITATION_IS_ACCEPTED_BY_DIFFERENT_CUSTOMER";
    ErrorCode["INVITATION_IS_ALREADY_ACCEPTED"] = "INVITATION_IS_ALREADY_ACCEPTED";
    ErrorCode["INVITATION_ALREADY_COMPLETED"] = "INVITATION_ALREADY_COMPLETED";
    ErrorCode["ALLOWED_DOMAINS_NOT_MATCHED"] = "ALLOWED_DOMAINS_NOT_MATCHED";
    ErrorCode["DEACTIVATING_ADMIN_USER_ERROR"] = "DEACTIVATING_ADMIN_USER_ERROR";
    ErrorCode["ASSIGN_PERMISSION_FAILURE"] = "ASSIGN_PERMISSION_FAILURE";
    ErrorCode["USER_IS_NOT_AUTHORIZED"] = "USER_IS_NOT_AUTHORIZED";
    ErrorCode["USER_DOES_NOT_EXIST"] = "USER_DOES_NOT_EXIST";
    ErrorCode["USER_IS_DEACTIVATED"] = "USER_IS_DEACTIVATED";
})(ErrorCode || (ErrorCode = {}));
